import React from 'react';
// import PricingBackground from '../../asset/PricingBackground.png';
import StarBlue from '../../asset/StarBlue.png';
import { useLocation } from 'react-router-dom';

export default function PricingPlan() {

    const location = useLocation();
    const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi';
    
    const scrollToBookATour = () => {
        const element = document.getElementById('book-a-tour');
        if (element) {
            const headerHeight = 105;
            const elementPosition = element.offsetTop - headerHeight;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div
            style={{ borderRadius: '20px' }}
            className="sm:flex bg-[#0B2342] w-[85%] mx-auto sm:w-[85%] items-center p-8 relative sm:h-[270px] justify-center px-4 sm:mx-auto sm:px-8 my-8"
        >
            <div className="flex w-full sm:flex-row flex-col justify-between items-center sm:items-center">
                {/* Left Section */}
                <div className="w-full sm:w-[33%] text-center sm:text-left font-regrade px-4 sm:px-8 font-semibold text-white">
                    <p className="text-[16px] sm:text-[18px]">TRANSPARENT PRICING</p>
                    <p className="text-[32px] sm:text-[48px] whitespace-nowrap">Simple Plans.</p>
                    <p className="text-[32px] sm:text-[48px] whitespace-nowrap">No Surprises.</p>
                    <p className="text-[14px] sm:text-[16px] font-normal">No Deposit. No Lock-In</p>
                </div>

                {/* Middle Pricing Box */}
                <div
                    style={{ border: '1.93px solid #C37FEDD4', borderRadius: '20px' }}
                    className="px-6 sm:px-8 py-4 bg-[#172d49] h-full flex flex-col justify-center mt-6 sm:mt-0"
                >
                    <p className="text-[#C37FED] text-[36px] sm:text-[46px] font-semibold">Monthly</p>
                    <p className="text-white ml-4 sm:ml-8 text-[28px] sm:text-[40px] font-sans font-semibold">
                        @₹{isperungudi ? "4,999" : "4,599"}
                        <span className="text-[14px] sm:text-[16px] font-normal">+GST</span>
                    </p>
                    <p
                        style={{ textDecorationColor: '#FF0000' }}
                        className="text-center text-[20px] sm:text-[27px] ml-10 sm:ml-20 font-semibold line-through text-white"
                    >
                        (₹8,999)
                    </p>
                </div>

                {/* Right Bullet Points */}
                <div className="w-full sm:w-[33%] items-center text-white flex flex-col justify-center gap-4 px-4 sm:px-8 mt-6 sm:mt-0">
                    <div className="flex items-start gap-2 text-center sm:text-left">
                        <p className="text-[16px] sm:text-[20px] font-semibold leading-tight">For a Limited Period Only</p>
                    </div>
                    <button
                        onClick={scrollToBookATour}
                        style={{ width: 'fit-content' }}
                        className="flex items-center h-fit whitespace-nowrap text-[12px] sm:text-[14px] font-semibold rounded-full px-3 sm:px-5 py-1.5 sm:py-2 bg-white text-[#232B6E] shadow-md hover:bg-gray-100 transition-colors"
                    >
                        <img className="h-[10px] w-[10px] mr-2" src={StarBlue} alt="star" />
                        Book Now!
                    </button>
                </div>
            </div>
        </div>

    );
}
